import { useState } from "react";
import { Menu, X } from "lucide-react";
import { SignInButton, SignUpButton, useUser } from '@clerk/clerk-react';

const MobileMenu = ({ scrolled = false, scrollToSection }) => {
    const [navOpen, setNavOpen] = useState(false);
    const { isSignedIn } = useUser();

    const handleNavigation = (sectionId) => {
        setNavOpen(false);
        if (scrollToSection) {
            scrollToSection(sectionId);
        }
    };

    return (
        <div className='block md:hidden relative'>
            {!navOpen ? (
                <button 
                    onClick={() => setNavOpen(true)}
                    className="text-white"
                >
                    <Menu size={32} />
                </button>
            ) : (
                <>
                    <button 
                        onClick={() => setNavOpen(false)}
                        className="text-white"
                    >
                        <X size={32} />
                    </button>
                    <div className={`absolute right-0 w-48 top-12 rounded-lg shadow-lg transition-all duration-300 ${
                        scrolled 
                            ? 'bg-white/25 backdrop-blur-xl border border-white/20' 
                            : 'bg-white/15 backdrop-blur-lg border border-white/10'
                    }`}>
                        <ul className="flex flex-col py-2">
                            {!isSignedIn ? (
                                <>
                                    <li>
                                        <button
                                            onClick={() => handleNavigation('features')}
                                            className="block text-white hover:text-white px-4 py-2 font-medium text-left w-full"
                                        >
                                            Features
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            onClick={() => handleNavigation('pricing')}
                                            className="block text-white hover:text-gray-200 px-4 py-2 font-medium text-left w-full"
                                        >
                                            Pricing
                                        </button>
                                    </li>
                                    <li className="px-4 py-2">
                                        <SignInButton mode="modal">
                                            <button className={`w-full text-gray-900 px-4 py-2 rounded-lg transition-all duration-300 ${
                                                scrolled 
                                                    ? 'bg-white/30 backdrop-blur-sm hover:bg-white/40 border border-white/20' 
                                                    : 'bg-white/15 hover:bg-white/25 border border-white/10'
                                            }`}>
                                                Login
                                            </button>
                                        </SignInButton>
                                    </li>
                                    <li className="px-4 py-2">
                                        <SignUpButton mode="modal">
                                            <button className="w-full bg-[#8B5CF6] text-white px-4 py-2 rounded-lg hover:bg-[#7C3AED]">
                                                Sign Up
                                            </button>
                                        </SignUpButton>
                                    </li>
                                </>
                            ) : (
                                <li className="px-4 py-2">
                                </li>
                            )}
                        </ul>
                    </div>
                </>
            )}
        </div>
    );
};

export default MobileMenu;
